module.exports = __webpack_public_path__ + "static/media/pencil.2d07279f.svg";